import React from "react";
import { ReactComponent as HomeIcon } from "../../../assets/icons/HomeIcon.svg";
import { ReactComponent as PatientsIcon } from "../../../assets/icons/PatientsIcon.svg";
import { ReactComponent as ChatIcon } from "../../../assets/icons/ChatIcon.svg";
import { ReactComponent as ResourcesIcon } from "../../../assets/icons/ResourcesIcon.svg";
import { ReactComponent as SettingsIcon } from "../../../assets/icons/SettingsIcon.svg";
import { ReactComponent as LogoutIcon } from "../../../assets/icons/LogoutIcon.svg";
import MenuItem from "./MenuItems";

const ClinicianMenu = ({ path, messageCount, handleLogout }) => {
  return (
    <div
      className="container-fluid sidebar-menu-container"
      style={{ position: "relative", height: "65%" }}
    >
      <div style={{ height: "2vh" }} />
      <div
        style={{
          height: "50vh",
          overflowY: "scroll",
        }}
      >
        <MenuItem
          href={"/dashboard/home/"}
          text={"Home"}
          selected={path.includes("home")}
        >
          <HomeIcon />
        </MenuItem>
        <MenuItem
          icon={PatientsIcon}
          href={"/patients/all"}
          text={"All Patients"}
          selected={path.includes("patients")}
        >
          <PatientsIcon />
        </MenuItem>
        <MenuItem
          icon={ResourcesIcon}
          href={"/resources/faq"}
          text={"Resources"}
          selected={path.includes("resources")}
        >
          <ResourcesIcon />
        </MenuItem>
        <MenuItem
          icon={ChatIcon}
          href={"/chat/"}
          text={"Chat"}
          selected={path.includes("chat")}
          count={messageCount}
        >
          <ChatIcon />
        </MenuItem>
        <MenuItem
          icon={SettingsIcon}
          href={"/settings/"}
          text={"Settings"}
          selected={path.includes("settings")}
        >
          <SettingsIcon />
        </MenuItem>
      </div>
      <hr style={{ color: "white", height: "2px", opacity: "100" }} />
      <div
        style={{
          position: "absolute",
          bottom: "2vh",
          width: "100%",
          padding: "0px",
          margin: "0px",
        }}
      >
        <MenuItem
          icon={LogoutIcon}
          onClick={handleLogout}
          href={""}
          text={"Logout"}
        >
          <LogoutIcon />
        </MenuItem>
      </div>
    </div>
  );
};

export default ClinicianMenu;
